module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginForm modal fade",
    attrs: {
      "id": "customerModal"
    }
  }, [_c('row', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('column', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('column', {
    staticClass: "col-md-4"
  }, [_c('va-box', {
    attrs: {
      "title": _vm.title,
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(0 > 1) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Customer Info",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("Customer Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "Customer Name"
    },
    domProps: {
      "value": _vm.name
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })])])])])])], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('va-box', {
    attrs: {
      "title": "Customer Info",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Customer Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "Customer Name"
    },
    domProps: {
      "value": _vm.name
    }
  })])])])])]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Search new printers scheduler",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Trigger: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.SearchTrigger),
      expression: "settings.SearchTrigger"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px",
      "text-align": "center"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.settings, "SearchTrigger", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "DAILY"
    }
  }, [_vm._v("DAILY")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WEEKLY"
    }
  }, [_vm._v("WEEKLY")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MONTHLY"
    }
  }, [_vm._v("MONTHLY")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settings.SearchTrigger === 'MONTHLY'),
      expression: "settings.SearchTrigger==='MONTHLY'"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("On Day: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.SearchRunOnDay),
      expression: "settings.SearchRunOnDay"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px",
      "text-align": "center"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.settings, "SearchRunOnDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.days), function(day) {
    return _c('option', {
      domProps: {
        "value": day
      }
    }, [_vm._v(_vm._s(day))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("On Time: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.SearchRunOnTime),
      expression: "settings.SearchRunOnTime"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px",
      "text-align": "center"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.settings, "SearchRunOnTime", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.hours), function(hour) {
    return _c('option', {
      domProps: {
        "value": hour
      }
    }, [_vm._v(_vm._s(hour))])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settings.SearchTrigger === 'WEEKLY'),
      expression: "settings.SearchTrigger==='WEEKLY'"
    }],
    staticClass: "form-group form-horizontal"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("On Day: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "checkbox inline",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SearchRunOnWeek[0]),
      expression: "SearchRunOnWeek[0]"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.SearchRunOnWeek[0]) ? _vm._i(_vm.SearchRunOnWeek[0], null) > -1 : (_vm.SearchRunOnWeek[0])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SearchRunOnWeek[0],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SearchRunOnWeek, 0, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SearchRunOnWeek, 0, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SearchRunOnWeek, 0, $$c)
        }
      }
    }
  }), _vm._v("SUN")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SearchRunOnWeek[1]),
      expression: "SearchRunOnWeek[1]"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.SearchRunOnWeek[1]) ? _vm._i(_vm.SearchRunOnWeek[1], null) > -1 : (_vm.SearchRunOnWeek[1])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SearchRunOnWeek[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SearchRunOnWeek, 1, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SearchRunOnWeek, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SearchRunOnWeek, 1, $$c)
        }
      }
    }
  }), _vm._v("MON")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SearchRunOnWeek[2]),
      expression: "SearchRunOnWeek[2]"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.SearchRunOnWeek[2]) ? _vm._i(_vm.SearchRunOnWeek[2], null) > -1 : (_vm.SearchRunOnWeek[2])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SearchRunOnWeek[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SearchRunOnWeek, 2, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SearchRunOnWeek, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SearchRunOnWeek, 2, $$c)
        }
      }
    }
  }), _vm._v("TUE")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SearchRunOnWeek[3]),
      expression: "SearchRunOnWeek[3]"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.SearchRunOnWeek[3]) ? _vm._i(_vm.SearchRunOnWeek[3], null) > -1 : (_vm.SearchRunOnWeek[3])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SearchRunOnWeek[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SearchRunOnWeek, 3, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SearchRunOnWeek, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SearchRunOnWeek, 3, $$c)
        }
      }
    }
  }), _vm._v("WED")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SearchRunOnWeek[4]),
      expression: "SearchRunOnWeek[4]"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.SearchRunOnWeek[4]) ? _vm._i(_vm.SearchRunOnWeek[4], null) > -1 : (_vm.SearchRunOnWeek[4])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SearchRunOnWeek[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SearchRunOnWeek, 4, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SearchRunOnWeek, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SearchRunOnWeek, 4, $$c)
        }
      }
    }
  }), _vm._v("THE")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SearchRunOnWeek[5]),
      expression: "SearchRunOnWeek[5]"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.SearchRunOnWeek[5]) ? _vm._i(_vm.SearchRunOnWeek[5], null) > -1 : (_vm.SearchRunOnWeek[5])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SearchRunOnWeek[5],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SearchRunOnWeek, 5, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SearchRunOnWeek, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SearchRunOnWeek, 5, $$c)
        }
      }
    }
  }), _vm._v("FRI")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SearchRunOnWeek[6]),
      expression: "SearchRunOnWeek[6]"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.SearchRunOnWeek[6]) ? _vm._i(_vm.SearchRunOnWeek[6], null) > -1 : (_vm.SearchRunOnWeek[6])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SearchRunOnWeek[6],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SearchRunOnWeek, 6, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SearchRunOnWeek, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SearchRunOnWeek, 6, $$c)
        }
      }
    }
  }), _vm._v("SAT")])])])])])])]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Get printers info scheduler",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Trigger: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.SendTrigger),
      expression: "settings.SendTrigger"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px",
      "text-align": "center"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.settings, "SendTrigger", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "DAILY"
    }
  }, [_vm._v("DAILY")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WEEKLY"
    }
  }, [_vm._v("WEEKLY")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MONTHLY"
    }
  }, [_vm._v("MONTHLY")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settings.SendTrigger === 'MONTHLY'),
      expression: "settings.SendTrigger==='MONTHLY'"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("On Day: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.SendRunOnDay),
      expression: "settings.SendRunOnDay"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px",
      "text-align": "center"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.settings, "SendRunOnDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.days), function(day) {
    return _c('option', {
      domProps: {
        "value": day
      }
    }, [_vm._v(_vm._s(day))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("On Time: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.SendRunOnTime),
      expression: "settings.SendRunOnTime"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px",
      "text-align": "center"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.settings, "SendRunOnTime", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.hours), function(hour) {
    return _c('option', {
      domProps: {
        "value": hour
      }
    }, [_vm._v(_vm._s(hour))])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settings.SendTrigger === 'WEEKLY'),
      expression: "settings.SendTrigger==='WEEKLY'"
    }],
    staticClass: "form-group form-horizontal"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("On Day: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "checkbox inline",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SendRunOnWeek[0]),
      expression: "SendRunOnWeek[0]"
    }],
    attrs: {
      "type": "checkbox",
      "value": "SUN"
    },
    domProps: {
      "checked": Array.isArray(_vm.SendRunOnWeek[0]) ? _vm._i(_vm.SendRunOnWeek[0], "SUN") > -1 : (_vm.SendRunOnWeek[0])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SendRunOnWeek[0],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "SUN",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SendRunOnWeek, 0, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SendRunOnWeek, 0, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SendRunOnWeek, 0, $$c)
        }
      }
    }
  }), _vm._v("SUN")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SendRunOnWeek[1]),
      expression: "SendRunOnWeek[1]"
    }],
    attrs: {
      "type": "checkbox",
      "value": "MON"
    },
    domProps: {
      "checked": Array.isArray(_vm.SendRunOnWeek[1]) ? _vm._i(_vm.SendRunOnWeek[1], "MON") > -1 : (_vm.SendRunOnWeek[1])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SendRunOnWeek[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "MON",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SendRunOnWeek, 1, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SendRunOnWeek, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SendRunOnWeek, 1, $$c)
        }
      }
    }
  }), _vm._v("MON")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SendRunOnWeek[2]),
      expression: "SendRunOnWeek[2]"
    }],
    attrs: {
      "type": "checkbox",
      "value": "TUE"
    },
    domProps: {
      "checked": Array.isArray(_vm.SendRunOnWeek[2]) ? _vm._i(_vm.SendRunOnWeek[2], "TUE") > -1 : (_vm.SendRunOnWeek[2])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SendRunOnWeek[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "TUE",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SendRunOnWeek, 2, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SendRunOnWeek, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SendRunOnWeek, 2, $$c)
        }
      }
    }
  }), _vm._v("TUE")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SendRunOnWeek[3]),
      expression: "SendRunOnWeek[3]"
    }],
    attrs: {
      "type": "checkbox",
      "value": "WED"
    },
    domProps: {
      "checked": Array.isArray(_vm.SendRunOnWeek[3]) ? _vm._i(_vm.SendRunOnWeek[3], "WED") > -1 : (_vm.SendRunOnWeek[3])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SendRunOnWeek[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "WED",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SendRunOnWeek, 3, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SendRunOnWeek, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SendRunOnWeek, 3, $$c)
        }
      }
    }
  }), _vm._v("WED")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SendRunOnWeek[4]),
      expression: "SendRunOnWeek[4]"
    }],
    attrs: {
      "type": "checkbox",
      "value": "THE"
    },
    domProps: {
      "checked": Array.isArray(_vm.SendRunOnWeek[4]) ? _vm._i(_vm.SendRunOnWeek[4], "THE") > -1 : (_vm.SendRunOnWeek[4])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SendRunOnWeek[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "THE",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SendRunOnWeek, 4, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SendRunOnWeek, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SendRunOnWeek, 4, $$c)
        }
      }
    }
  }), _vm._v("THE")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SendRunOnWeek[5]),
      expression: "SendRunOnWeek[5]"
    }],
    attrs: {
      "type": "checkbox",
      "value": "FRI"
    },
    domProps: {
      "checked": Array.isArray(_vm.SendRunOnWeek[5]) ? _vm._i(_vm.SendRunOnWeek[5], "FRI") > -1 : (_vm.SendRunOnWeek[5])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SendRunOnWeek[5],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "FRI",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SendRunOnWeek, 5, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SendRunOnWeek, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SendRunOnWeek, 5, $$c)
        }
      }
    }
  }), _vm._v("FRI")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SendRunOnWeek[6]),
      expression: "SendRunOnWeek[6]"
    }],
    attrs: {
      "type": "checkbox",
      "value": "SAT"
    },
    domProps: {
      "checked": Array.isArray(_vm.SendRunOnWeek[6]) ? _vm._i(_vm.SendRunOnWeek[6], "SAT") > -1 : (_vm.SendRunOnWeek[6])
    },
    on: {
      "change": function($event) {
        var $$a = _vm.SendRunOnWeek[6],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "SAT",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.SendRunOnWeek, 6, $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.SendRunOnWeek, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.SendRunOnWeek, 6, $$c)
        }
      }
    }
  }), _vm._v("SAT")])])])])])])]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Printers status",
      "isBorder": true,
      "theme": "box-warning",
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Check printers status every ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.CheckStatusEvery),
      expression: "settings.CheckStatusEvery"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": "1000"
    },
    domProps: {
      "value": (_vm.settings.CheckStatusEvery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "CheckStatusEvery", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("minutes ")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "align": "center"
    }
  }, [_c('va-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticStyle: {
      "width": "98%"
    },
    attrs: {
      "type": "danger",
      "dismissible": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.error) + "\n                ")])])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Cancel",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }), _vm._v(" "), _c('va-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "isBlock": false,
      "theme": "success",
      "name": "Save",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  })], 1)])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-md-4"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76ef5f64!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddCustomer.vue
// module id = 727
// module chunks = 0